import axios, { AxiosProgressEvent } from "axios";
import { settings } from "../../customize/settings";
import { IBaseError } from "../../interfaces/errors";
import {
	IProspectImage,
	IProspectImageUpdate,
	IProspectImageUpload
} from "../../interfaces/prospect/models";
import {
	IDeleteResponse,
	IListResponse,
	IStoreResponse,
	IUpdateResponse
} from "../../interfaces/rest";
import { getJWT } from "../../lib/jwt";

const BASE_URL = `${settings.apiUrl}prospect-image`;

export const getProspectImageList = async (idProspect: number): Promise<IListResponse<IProspectImage>> => {
	const url = `${BASE_URL}/list?idProspect=${idProspect}`;
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	const jwt = getJWT();
	if (jwt) headers.append("Authorization", "Bearer " + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers
	});
	const json: IListResponse<IProspectImage> | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IListResponse<IProspectImage>;
};

export const updateProspectImage = async (id: number, data: IProspectImageUpdate): Promise<IUpdateResponse> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	const jwt = getJWT();
	if (jwt) headers.append("Authorization", "Bearer " + jwt);
	const body = JSON.stringify(data);
	const response = await fetch(url, {
		method: "PUT",
		headers,
		body
	});
	const json: IUpdateResponse | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IUpdateResponse;
};

export const removeProspectImage = async (id: number): Promise<IDeleteResponse> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	const jwt = getJWT();
	if (jwt) headers.append("Authorization", "Bearer " + jwt);
	const response = await fetch(url, {
		method: "DELETE",
		headers
	});
	const json: IDeleteResponse | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IDeleteResponse;
};

export const uploadProspectImage = async (
	data: IProspectImageUpload,
	onUploadProgress: (progress: AxiosProgressEvent) => void = () => null
): Promise<IStoreResponse> => {
	const { idProspect, image, name } = data;
	const url = `${BASE_URL}`;
	const headers: Record<string, string> = {
		"Content-Type": "multipart/form-data"
	};
	const jwt = getJWT();
	if (jwt) headers["Authorization"] = "Bearer " + jwt;
	const formData = new FormData();
	formData.append("idProspect", String(idProspect));
	formData.append("image", image);
	if (name) formData.append("name", name);
	const response = await axios.request({
		method: "post",
		url,
		headers,
		data: formData,
		onUploadProgress
	});
	const json: IStoreResponse | IBaseError = response.data;
	if (response.status !== 200) throw json;
	return json as IStoreResponse;
};
